export default __webpack_public_path__ + "static/media/IMG_5090.18e57ebf.png";